// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1sN5M","bigColWidth":"Table_bigColWidth__2UPpR","biggerColWidth":"Table_biggerColWidth__1TiK5","row":"Table_row__1N8yR","col":"Table_col__3GnmO"};